import api from '../../infra/api';

class servDownloads {
  async Listar(pesquisaGeral, tipos = []) {

    let filtros = [
      {
        property: "Ativo",
        operator: "in",
        value: [1]
      }
    ];

    if (pesquisaGeral && pesquisaGeral.trim() !== "") {
      filtros.push(
        {
          property: "Titulo",
          operator: "containsall",
          value: pesquisaGeral
        },
        {
          property: "Descricao",
          operator: "containsall",
          value: pesquisaGeral
        },
        {
          property: "NomeArquivo",
          operator: "containsall",
          value: pesquisaGeral
        }
      );
    }

    if (tipos.length > 0) {
      filtros.push({
        property: "TipoDocumento",
        operator: "in",
        value: tipos
      });
    }

    const url = `/api/v1/DocumentosModelos?page=1&start=0&limit=999
  &fields=["Id","CodigoVisual","CodigoDocumento","Titulo","Descricao","NomeArquivo","TamanhoKb","TipoDocumento","Ativo","DataApresentacao"]
  &sort=[{"property":"CodigoVisual","direction":"DESC"}]
  &filter=${encodeURIComponent(JSON.stringify(filtros))}`;

    const response = await api({
      method: "GET",
      url: url
    });

    return response.data;
  }

  async RealizarDownloadDocumento(codigoDocumentoModelo) {
    const response = await api({
      method: "GET",
      url: `/api/v1/DocumentosModelos/RealizarDownloadDocumento/${codigoDocumentoModelo}`
    });

    return response.data;
  }
}

export default new servDownloads();